// extracted by mini-css-extract-plugin
export var divider = "_4c-0";
export var dividerText = "_4c-1";